import Dialog from '@utils/common/dialog'
import Form from '@utils/form'

// 审批
const approvalForm = new Form('inquiry.approvalTracking')
  .setSpan(24)
  .add('approvalOpinion').label('').component('el-input').attrs({ type: 'textarea', rows: 4 }).placeholder('placeholder')

const approvalForm1 = new Form('inquiry.approvalTracking')
  .setSpan(24)
  .add('approvalOpinion').label('').component('el-input').attrs({ type: 'textarea', rows: 4 }).placeholder('placeholder1')

const approvalDialog = new Dialog('inquiry.approvalTracking')
  .title('titleName')
  .dialog({ width: '510px' })
  .form(approvalForm1)
  .validate(async() => {
    return true
  })

const rejectDialog = new Dialog('inquiry.approvalTracking')
  .title('rejectName')
  .dialog({ width: '510px' })
  .form(approvalForm)
  .validate(async() => {
    return true
  })

export {
  approvalDialog,
  rejectDialog
}
